module.exports = __webpack_public_path__ + "../static/favicon-cbb281dc96f2f3354ea905159c465595.ico";